import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Row, Col, Checkbox, message, InputNumber} from 'antd';

import {fetchSettings, addSetting, deleteSetting, updateSetting} from '../../../actions';

class Settings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serverErrors: null
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const {settings: {isFetching, error}} = nextProps;
        if (isFetching) {
            return null;
        }

        if (error) {
            return {...prevState, serverErrors: error}
        }
        if (!error && prevState.serverErrors) {
            return {...prevState, serverErrors: null}
        }

        return null;
    }
    static notifySuccess() {
        message.success('Successfully updated')
    }
    static notifyError(errors) {
        const errs = typeof errors === 'string' ? errors : Object.keys(errors).map(key => errors[key].map((e, i) => <span key={i}>{e}</span>));
        message.error(errs);
    }
    handlePostSubmit() {
        const {state: {serverErrors}} = this;
        if (!serverErrors) {
            Settings.notifySuccess();
            return;
        }

        const {res: {errors, message}} = serverErrors;
        Settings.notifyError(errors || message);
    }
    render() {
        const {settings: {data, isFetching}, addSetting, deleteSetting, updateSetting, landlord: {id}} = this.props;
        const onToggle = field => e => {
            const {checked} = e.target;
            const method = checked ? addSetting : deleteSetting;
            return method(id, field).then(() => this.handlePostSubmit());
        };
        const onChange = (field, config) => e => {
            const method = config ? updateSetting : addSetting;
            field = config ? config.id : field;
            return method(id, field, e.target.value).then(() => this.handlePostSubmit());
        };
        const renderBooleanSetting = ({name = '', id = '', config = null}) => (
            <Row key={id}>
                <Col span={6}><p>{name} </p></Col>
                <Col span={2}><Checkbox checked={!!config} onChange={onToggle(id)}/></Col>
            </Row>
        );

        const renderIntegerSetting = ({name = '', id = '', config = null}) => (
            <Row key={id}>
                <Col span={8}><p>{name} </p></Col>
                <Col span={2}><InputNumber size="small" defaultValue={config && config.integer_value} onBlur={onChange(id, config)}/></Col>
            </Row>
        );

        return (
            <Card title="Engineer Settings" loading={isFetching} bordered={false}>
                <Row gutter={16}>
                    <Col md={{span: 12}}>
                        {data.filter(i => i.type === 'boolean').map(renderBooleanSetting)}
                    </Col>
                    <Col md={{span: 12}}>
                        {data.filter(i => i.type === 'integer').map(renderIntegerSetting)}
                    </Col>
                </Row>
            </Card>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        settings: state.landlord.dlo.settings,
        landlord: state.me.application
    }
};
export default connect(mapStateToProps, {
    addSetting,
    deleteSetting,
    updateSetting
})(Settings);


// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/DLO/Settings.js